
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/celebrity/[slug]",
      function () {
        return require("private-next-pages/celebrity/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/celebrity/[slug]"])
      });
    }
  